export default "__VITE_ASSET__3f80671e__"